import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export function TikTokEmbedLoader() {
  const location = useLocation();

  useEffect(() => {
    const removeScript = () => {
      const existing = document.querySelector('script[src="https://www.tiktok.com/embed.js"]');
      if (existing) existing.remove();
    };

    const addScript = () => {
      const script = document.createElement("script");
      script.src = "https://www.tiktok.com/embed.js";
      script.async = true;
      document.body.appendChild(script);
    };

    removeScript();
    addScript();
    return () => removeScript();
  }, [location.pathname]);

  return null;
}